// extracted by mini-css-extract-plugin
module.exports = {"action":"EmailConfiguration_action__2dYO4","recipient":"EmailConfiguration_recipient__1RYd0"};